export default "<p>userforgotpassword works!</p>\n"